import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './buttonGroup.scss'

const ButtonGroup = ({ children, orientation }) => {
	const buttonGroupClass = 'o-button-group'
	const cssClasses = classNames(
		buttonGroupClass,
		`${buttonGroupClass}--${orientation}`
	)

	return <div className={cssClasses}>{children}</div>
}

ButtonGroup.propTypes = {
	children: PropTypes.node,
	orientation: PropTypes.oneOf(['horizontal', 'vertical']),
}

ButtonGroup.defaultProps = {
	children: null,
	orientation: 'vertical',
}

export default ButtonGroup
